/* Valvaro: welkomst-pop-up en voortgangsbalk winkelwagen (v20) */
import { CartUpdateEvent } from '@theme/events';

const C = Object.assign({
  code: 'WELKOM10', min: '€45', img: '', delay: 20000, days: 7, template: '',
  deken: 'wearable-fleece-deken', p1: 5495, p2: 8999, p3: 11999, s2: 1991, s3: 4486,
}, window.vvG || {});

const ls = {
  get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
  set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
};
const eur = (c) => '€' + (c / 100).toFixed(2).replace('.', ',');
const ICON_GIFT = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#E0AE4C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="13" rx="2"/><path d="M12 8v13M3 12h18M12 8c-1.5-3-5-4-6-2s2 2 6 2zm0 0c1.5-3 5-4 6-2s-2 2-6 2z"/></svg>';
const ICON_X = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
const ICON_OK = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
const ICON_CHECK = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
const ICON_PLUS = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';

/* ---------- Welkomst-pop-up ---------- */
function initPopup() {
  if (C.template === 'cart' || location.pathname.indexOf('/checkout') === 0) return;
  if (window.Shopify && window.Shopify.designMode) return;
  const pending = ls.get('vv_pending');
  const posted = !!(pending && document.querySelector('[data-vv-posted]'));
  const failed = !!(pending && document.querySelector('[data-vv-errors]'));
  if (pending) ls.set('vv_pending', '');
  if (posted) ls.set('vv_sub', '1');
  if (ls.get('vv_sub') === '1' && !posted) return;

  const tab = document.createElement('button');
  tab.type = 'button';
  tab.className = 'vv-tab';
  tab.innerHTML = ICON_GIFT + '<span>10% welkomstkorting</span>';

  const pop = document.createElement('div');
  pop.className = 'vv-pop';
  pop.innerHTML =
    '<div class="vv-pop__bg" data-close></div>' +
    '<div class="vv-pop__box" role="dialog" aria-modal="true" aria-labelledby="vv-pop-t">' +
      '<div class="vv-pop__img"><img src="' + C.img + '" alt="Twee mensen op de bank in een wearable fleece deken" width="600" height="750"></div>' +
      '<div class="vv-pop__body">' +
        '<button type="button" class="vv-pop__x" aria-label="Sluiten" data-close>' + ICON_X + '</button>' +
        '<div data-vv-formslot></div>' +
        '<div class="vv-pop__step" data-step="done" hidden>' +
          '<div style="display:flex;flex-direction:column;gap:16px">' +
          '<div class="vv-pop__ok">' + ICON_OK + '</div>' +
          '<h2 tabindex="-1">Gelukt! Dit is je code</h2>' +
          '<div class="vv-pop__code"><span>' + C.code + '</span><button type="button" class="vv-pop__copy" data-copy>Kopieer</button></div>' +
          '<p>10% korting op een bestelling vanaf ' + C.min + ', één keer per klant.</p>' +
          '<button type="button" class="vv-pop__btn" data-apply>Code toepassen en verder winkelen</button>' +
          '<p class="vv-pop__small">De knop zet de code alvast klaar voor het afrekenen.</p>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';

  const holder = document.getElementById('vv-popform');
  const form = holder && holder.querySelector('form');
  if (!form) return;
  pop.querySelector('[data-vv-formslot]').replaceWith(form);
  holder.remove();
  document.body.append(tab, pop);
  const input = form.querySelector('input[type=email]');
  const err = pop.querySelector('.vv-pop__err');
  let lastFocus = null;

  const dismissedRecently = () => {
    const t = parseInt(ls.get('vv_dis') || '0', 10);
    return t && Date.now() - t < C.days * 864e5;
  };
  const open = () => {
    if (pop.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    pop.classList.add('is-open');
    tab.classList.remove('is-on');
    setTimeout(() => (form.hidden ? pop.querySelector('h2[tabindex]') : input).focus({ preventScroll: true }), 50);
  };
  const close = () => {
    pop.classList.remove('is-open');
    if (ls.get('vv_sub') !== '1') {
      ls.set('vv_dis', String(Date.now()));
      tab.classList.add('is-on');
    }
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  };

  tab.addEventListener('click', open);
  pop.addEventListener('click', (e) => { if (e.target.closest('[data-close]')) close(); });
  document.addEventListener('keydown', (e) => {
    if (!pop.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') {
      const f = [...pop.querySelectorAll('button,input')].filter((x) => x.offsetParent !== null);
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  form.addEventListener('submit', (e) => {
    const email = input.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { e.preventDefault(); err.textContent = 'Vul een geldig e-mailadres in.'; input.focus(); return; }
    err.textContent = '';
    ls.set('vv_pending', String(Date.now()));
  });

  pop.querySelector('[data-copy]').addEventListener('click', async (e) => {
    const b = e.currentTarget;
    try { await navigator.clipboard.writeText(C.code); b.textContent = 'Gekopieerd'; } catch (x) { b.textContent = C.code; }
  });
  pop.querySelector('[data-apply]').addEventListener('click', async (e) => {
    e.currentTarget.disabled = true;
    try { await fetch('/discount/' + encodeURIComponent(C.code) + '?redirect=/', { credentials: 'same-origin' }); } catch (x) {}
    pop.classList.remove('is-open');
  });

  if (posted) {
    form.hidden = true;
    pop.querySelector('[data-step="done"]').hidden = false;
    tab.remove();
    try { if (location.search.indexOf('customer_posted') > -1) history.replaceState(null, '', location.pathname + location.hash.replace(/#.*/, '')); } catch (x) {}
    open();
    return;
  }
  if (failed) { err.textContent = 'Dat lukte niet. Controleer je e-mailadres en probeer het opnieuw.'; open(); return; }
  if (dismissedRecently()) { tab.classList.add('is-on'); return; }
  const isMobile = window.matchMedia('(max-width: 749px)').matches;
  setTimeout(() => { if (!isMobile || !pop.classList.contains('is-open')) tab.classList.add('is-on'); }, 4000);
  const timer = setTimeout(open, C.delay);
  if (!isMobile) {
    document.addEventListener('mouseout', function exit(ev) {
      if (!ev.relatedTarget && ev.clientY <= 0) { clearTimeout(timer); document.removeEventListener('mouseout', exit); open(); }
    });
  }
}

/* ---------- Voortgangsbalk en wissel-tip winkelwagen ---------- */
const prodCache = {};
async function getProduct(handle) {
  if (!prodCache[handle]) prodCache[handle] = fetch('/products/' + handle + '.js').then((r) => r.json()).catch(() => null);
  return prodCache[handle];
}

let busy = false;
async function updateCart(updates) {
  if (busy) return;
  busy = true;
  document.querySelectorAll('.vv-prog,.vv-up').forEach((n) => n.classList.add('vv-busy'));
  const ids = new Set();
  document.querySelectorAll('cart-items-component[data-section-id]').forEach((n) => ids.add(n.dataset.sectionId));
  try {
    const r = await fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates, sections: [...ids].join(','), sections_url: location.pathname }),
    });
    const cart = await r.json();
    if (cart.status && cart.status >= 400) throw new Error(cart.description || 'fout');
    document.dispatchEvent(new CartUpdateEvent(cart, 'vv-gamify', { itemCount: cart.item_count, source: 'vv-gamify', sections: cart.sections }));
  } catch (x) {
    location.reload();
  } finally {
    busy = false;
    setTimeout(render, 150);
  }
}

function progHTML(q, color) {
  let txt;
  if (q === 1) txt = 'Nog 1 deken en je betaalt ' + eur(C.p2) + ' voor 2. Je <strong>bespaart ' + eur(C.s2) + '</strong>.';
  else if (q === 2) txt = 'Top! Je betaalt ' + eur(C.p2) + ' voor 2 dekens. Neem er 3 voor ' + eur(C.p3) + ' en <strong>bespaar ' + eur(C.s3) + '</strong>.';
  else txt = 'Top! Je hebt de beste prijs: 3 voor ' + eur(C.p3) + '. Je <strong>bespaart ' + eur(C.s3) + '</strong>.';
  const fill = q >= 3 ? 'calc(100% - 24px)' : q === 2 ? 'calc(50% - 12px)' : '0%';
  const dot = (n) => {
    if (n <= q) return '<div class="vv-prog__dot is-done">' + (q === 1 ? '1' : ICON_CHECK) + '</div>';
    return '<div class="vv-prog__dot' + (n === q + 1 ? ' is-next' : '') + '">' + n + '</div>';
  };
  const lab = (n, t) => '<span' + (n === Math.min(q + 1, 3) ? ' class="is-cur"' : '') + '>' + t + '</span>';
  return '<p class="vv-prog__txt">' + txt + '</p>' +
    '<div class="vv-prog__bar" aria-hidden="true"><div class="vv-prog__track"></div><div class="vv-prog__fill" style="width:' + fill + '"></div>' +
    '<div class="vv-prog__dots">' + dot(1) + dot(2) + dot(3) + '</div></div>' +
    '<div class="vv-prog__labels" aria-hidden="true">' + lab(1, '1 deken') + lab(2, '2 voor ' + eur(C.p2)) + lab(3, '3 voor ' + eur(C.p3)) + '</div>' +
    (q < 3 ? '<button type="button" class="vv-prog__add" data-vv-add>' + ICON_PLUS + 'Nog een deken toevoegen' + (color ? ' (' + color + ')' : '') + '</button>' : '');
}

let rendering = false;
let again = false;
async function render() {
  if (rendering || busy) { again = true; return; }
  const wrap = document.querySelector('cart-items-component .cart-items__wrapper');
  if (!wrap) return;
  rendering = true;
  try {
    const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
    // Deken-voortgang
    const dek = cart.items.filter((i) => i.handle === C.deken);
    const q = dek.reduce((s, i) => s + i.quantity, 0);
    let box = wrap.querySelector('.vv-prog');
    if (!q) { box && box.remove(); }
    else {
      const first = dek[0];
      const color = first.options_with_values && first.options_with_values[0] ? first.options_with_values[0].value : '';
      const html = progHTML(q, color);
      if (!box) { box = document.createElement('div'); box.className = 'vv-prog'; box.setAttribute('role', 'status'); wrap.prepend(box); }
      if (box.dataset.k !== html) { box.innerHTML = html; box.dataset.k = html; }
      const add = box.querySelector('[data-vv-add]');
      if (add) add.onclick = () => updateCart({ [first.variant_id]: first.quantity + 1 });
    }
    // Wissel naar 2 stuks
    for (const item of cart.items) {
      const row = document.querySelector('tr[data-key="' + item.key + '"] .cart-items__details');
      if (!row) continue;
      const ow = item.options_with_values || [];
      const ai = ow.findIndex((o) => o.name === 'Aantal');
      let tip = row.querySelector('.vv-up');
      if (ai < 0 || ow[ai].value !== '1 stuk' || item.quantity !== 1) { tip && tip.remove(); continue; }
      const p = await getProduct(item.handle);
      if (!p) continue;
      const v2 = p.variants.find((v) => v.available !== false && v.options.every((val, idx) => (idx === ai ? val === '2 stuks' : val === ow[idx].value)));
      if (!v2) { tip && tip.remove(); continue; }
      const save = item.price * 2 - v2.price;
      if (save <= 0) { tip && tip.remove(); continue; }
      const html = '<span class="vv-up__txt">Neem 2 stuks voor ' + eur(v2.price) + ' en <strong>bespaar ' + eur(save) + '</strong></span><button type="button" class="vv-up__btn">Wissel naar 2 stuks</button>';
      if (!tip) { tip = document.createElement('div'); tip.className = 'vv-up'; row.append(tip); }
      if (tip.dataset.k !== html) { tip.innerHTML = html; tip.dataset.k = html; }
      tip.querySelector('button').onclick = () => updateCart({ [item.variant_id]: 0, [v2.id]: 1 });
    }
  } catch (x) {
    /* stil falen: winkelwagen werkt gewoon door */
  } finally {
    rendering = false;
    if (again) { again = false; setTimeout(render, 150); }
  }
}

function initCart() {
  if (C.template !== 'cart') return;
  let t;
  const later = () => { clearTimeout(t); t = setTimeout(render, 120); };
  render();
  document.addEventListener('cart:update', later);
  const target = document.querySelector('cart-items-component') || document.body;
  new MutationObserver(later).observe(target, { childList: true, subtree: true });
}

const start = () => { initPopup(); initCart(); };
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
